import { convertDBDefinedModelToModelDefObject } from '../../../common/modelDefinitions/convertDBDefinedModelToModelDefObject'
import { DBDefinedModelDefinitionColumns } from '../../../common/modelDefinitions/DBDefinedModelDefinitionColumns'
import { ModelDef } from '../../../types'

export const core_user_meta__dbDefineable: DBDefinedModelDefinitionColumns = {
  id: 'd2c85385-a14b-450d-a2cd-c87c63cf7c65',
  tableName: 'core_user_meta',
  tableLabel: 'ユーザーメタデータ',
  tableComment:
    '各種設定値などを保存できる user 用の meta table. id 値は 基本的に ${userId}-${key} という形式で利用する想定。 Front 側からは $core.$userMetaData を通じて利用。',
  primaryKeyColType: 'STRING',
  otherModelAttributes: `/**
 * @type {ModelDefPartial<ModelDataTypes['core_user_meta']>}
 */
const modelDef = {
  modelType: 'admin',
  extensions: [
    {
      enabled: true,
      extensionType: 'cachedFindable',
      key: 'cachedFindable',
    },
  ]
}
return modelDef
`,
  columns: [
    {
      key: 'id',
      label: 'ID',
      type: 'STRING',
    },
    {
      key: 'user',
      label: 'ユーザーID',
      type: 'UUID',
    },
    {
      key: 'key',
      label: 'キー',
      type: 'STRING',
    },
    {
      key: 'category',
      label: 'カテゴリ',
      type: 'STRING',
    },
    {
      key: 'value',
      label: 'データ',
      type: 'JSON',
    },
  ],
}

export type ModelCoreUserMeta = {
  id: string
  user: string
  key: string
  category: string
  value: any
}

export const core_user_meta: Promise<ModelDef> = convertDBDefinedModelToModelDefObject(
  core_user_meta__dbDefineable,
)
